// This is the default environment file for local development builds.
// Production builds replace this file with `environment.prod.ts` via `fileReplacements`.
// The list of file replacements can be found in `angular.json`.
// Replace the RiskApiAddress with your local host URL for the Risk API, e.g. 'https://localhost:5001'

export const environment = {
    production: false,
    RiskApiAddress: 'https://risk-api.sf-dev.net/',
    authConfig: {
      tenant: '74d00ee0-2f86-4ba5-8d93-499fa9d4cb41',
      clientId: '95548eeb-a802-494f-b165-097193689d68',
      
    }
};

/*
 *  RiskApiAddress: 'https://localhost:5001', 'https://tfs.cimsr.ngrok.io'
 *
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
